// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './redux/store';
import App from './App';
import './styles/tailwind.css';
import './styles/index.css';
import './styles/font.css';
import { SocketProvider } from './Socket';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <SocketProvider>
  <Provider store={store}>
    <App />
  </Provider>
  </SocketProvider>
);
